<template>
	<div>
		<div class="row">
			<div class="col-12">
				<label class="font28 font500"><i class="fa fa-bullhorn fa-13"></i> จัดการโปรโมชั่น</label>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-12 col-md-12">
				<div class="row">
					<div class="col-12 col-md-4 py-1 px-2">
						<router-link to="Managepromotion">
							<button type="button" class="btn btn-cancel color_white font12" style="font-weight:400;"><i
									class="fas fa-angle-double-left"></i> ย้อนกลับ</button>
						</router-link>
						เพิ่มโปรโมชั่น
					</div>
				</div>
				<div class="row">
					<div class="col-12 py-1">
						<div class="bg-blue font14">
							<div>1. เพิ่มโปรโมชั่นการใช้งานในระบบ</div>
						</div>
					</div>
				</div>
				<div class="row justify-content-center mt-3">
					<div class="col-12 col-md-8">
						<div class="border-detail">
							<div class="row justify-content-center py-4">
								<div class="col-12 col-md-8 px-4">
									โปรโมชั่น
									<div class="input-group">
										<div class="input-group-prepend">
											<span class="input-group-text" id="basic-addon">
												<mdb-icon far icon="edit" />
											</span>
										</div>
										<input type="text" v-model="pro_name" class="form-control"
											aria-describedby="basic-addon" @keypress="isCharacter($event)" />
									</div>
								</div>
								<div class="col-12 col-md-8 px-4 pt-2">
									ราคา
									<div class="input-group">
										<div class="input-group-prepend">
											<span class="input-group-text" id="basic-addon">
												<mdb-icon far icon="edit" />
											</span>
										</div>
										<input type="text" v-model="pro_price" class="form-control"
											aria-describedby="basic-addon" @keypress="isNumber($event)" /><span
											class=" align-self-center pl-4">บาท</span>
									</div>
								</div>
								<div class="col-12 col-md-8 px-4 pt-2">
									จำนวนเครดิตที่ได้
									<div class="input-group">
										<div class="input-group-prepend">
											<span class="input-group-text" id="basic-addon">
												<mdb-icon far icon="edit" />
											</span>
										</div>
										<input type="text" v-model="pro_credit" class="form-control"
											aria-describedby="basic-addon" @keypress="isNumber($event)" /><span
											class=" align-self-center pl-4">บาท</span>
									</div>
								</div>
								<div class="col-12 col-md-8 px-4 pt-2">
									อายุการใช้งาน
									<div class="input-group">
										<div class="input-group-prepend">
											<span class="input-group-text" id="basic-addon">
												<mdb-icon far icon="edit" />
											</span>
										</div>
										<input type="text" v-model="expire_date" class="form-control"
											aria-describedby="basic-addon" @keypress="isNumber($event)" /><span
											class=" align-self-center pl-3">เดือน</span>
									</div>
								</div>
								<div class="col-12 col-md-8 px-4 pt-2">
									ชื่อผู้ส่ง
									<div class="input-group">
										<div class="input-group-prepend">
											<span class="input-group-text" id="basic-addon">
												<mdb-icon far icon="edit" />
											</span>
										</div>
										<input type="text" v-model="amount_sender" class="form-control"
											aria-describedby="basic-addon" @keypress="isNumber($event)" /><span
											class=" align-self-center pl-3">จำนวน</span>
									</div>
								</div>
								<div class="col-12 col-md-8 px-4 pt-2">
									<div class="row">
										<div class="col-3 col-md-3 align-self-center">สถานะ</div>
										<div class="col-3 col-md-2 px-0">
											<label class="switch" style="">
												<input type="checkbox" v-model="status" />
												<span class="slider round"></span>
											</label>
										</div>
										<div class="col-6 col-md-7 align-self-center pl-0">ปิด - เปิด</div>
									</div>
								</div>
								<div class="col-12 col-md-8 px-4 pt-2">
									<div class="row">
										<div class="col-4 col-md-3 align-self-center">กลุ่มลูกค้า</div>
										<div class="col-7  col-md-9 pl-0">
											<div class="d-flex">
												<div class="form-check pl-0">
													<input class="form-check-input" type="radio" name="exampleRadios"
														id="one" value="member" v-model="pro_type">
													<label class="mb-0" for="one">member</label>
												</div>
												<div class="form-check">
													<input class="form-check-input" type="radio" name="exampleRadios"
														id="two" value="VIP" v-model="pro_type">
													<label class="mb-0" for="two">VIP</label>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-12 col-md-8 text-center mt-4">
									<button type="button" class="btn btn-Send-Request color_white mr-3 font14"
										style="font-weight:400;" @click="SaveOnClick()">
										<mdb-icon icon="check" /> ตกลง</button>
									<router-link to="Setupsender">
										<button type="button" class="btn btn-cancel color_white font14"
											style="font-weight:400;"><i class="fas fa-times"></i> ยกเลิก</button>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// import $ from 'jquery'
	// import moment from 'moment'
	import {
		mapGetters,
		mapActions
	} from 'vuex'
	// const jwt = require('jsonwebtoken')
	export default {
		name: 'Setupsenderadd',
		data() {
			return {
				pro_name: '',
				pro_price: '',
				pro_credit: '',
				pro_type: "member",
				expire_date: '',
				amount_sender: '',
				status: 0,
			}
		},
		computed: {
			...mapGetters({
				isLogin: 'isLogin',
				user: 'user',
				token: 'token',
			}),
		},
		methods: {
			...mapActions({
				storeLogin: 'login',
				storeLoout: 'logout',
				loadsession: 'loadsession',
				callApiMotherFucker: 'callApiMotherFucker',
			}),
			isCharacter: function (evt) {
				evt = evt ? evt : window.event
				var charCode = evt.which ? evt.which : evt.keyCode
				if (charCode < 32 || (charCode > 33 && charCode < 48) || (charCode > 57 && charCode < 65) || (
						charCode > 90 && charCode < 97) || (charCode > 122 && charCode == 32)) {
					evt.preventDefault()
				} else {
					return true
				}
			},
			isNumber: function (evt) {
				evt = evt ? evt : window.event
				var charCode = evt.which ? evt.which : evt.keyCode
				if (charCode < 48 || charCode > 57) {
					evt.preventDefault()
				} else {
					return true
				}
			},
			SaveOnClick() {
				if (this.pro_name == '' || this.pro_name == null) {
					return this.$swal({
						html: '<i class="fa fa-user-circle fa-6x"></i><br><br>กรุณากรอกชื่อโปรโมชั่น<br>',
						timer: 5000,
						showConfirmButton: true,
						allowOutsideClick: false,
						allowEscapeKey: false,
					})
				}
				if (this.pro_price == '' || this.pro_price == null) {
					return this.$swal({
						icon: 'info',
						html: 'กรุณากรอกราคา<br>',
						timer: 5000,
						showConfirmButton: true,
						allowOutsideClick: false,
						allowEscapeKey: false,
					})
				}
				if (this.pro_credit == '' || this.pro_credit == null) {
					return this.$swal({
						icon: 'info',
						html: 'กรุณากรอกจำนวนเครดิตที่ได้<br>',
						timer: 5000,
						showConfirmButton: true,
						allowOutsideClick: false,
						allowEscapeKey: false,
					})
				}
				if (this.expire_date == '' || this.expire_date == null) {
					return this.$swal({
						icon: 'info',
						html: 'กรุณากรอกอายุการใช้งาน<br>',
						timer: 5000,
						showConfirmButton: true,
						allowOutsideClick: false,
						allowEscapeKey: false,
					})
				}
				this.callApiMotherFucker({
					method: 'PUT',
					path: '/promotion',
					data: {
						pro_name: this.pro_name,
						pro_type: this.pro_type,
						pro_price: this.pro_price,
						pro_credit: this.pro_credit,
						expire_date: this.expire_date,
						amount_sender: this.amount_sender,
						status: this.status ? 1 : 0
					},
				}).then((res) => {
					if (res.code == 0) {
						this.$swal({
							icon: 'success',
							html: res.msg,
							timer: 8000,
							showConfirmButton: true,
							allowOutsideClick: false,
							allowEscapeKey: false,
						})
						this.$router.push('/Managepromotion')
					} else {
						this.$swal({
							icon: 'error',
							html: res.msg,
							timer: 8000,
							showConfirmButton: true,
							allowOutsideClick: false,
							allowEscapeKey: false,
						})
						this.$router.push('/Managepromotion')
					}
				})
			},
		},
		mounted() {},
	}
</script>
<style scoped>
	.fa-13 {
		font-size: 1em;
	}

	.field-icon {
		margin-left: 25px;
		margin-right: 10px;
		margin-top: 0px;
		position: relative;
		z-index: 2;
	}

	.border-detail {
		border: 1px solid #cccccc;
		box-sizing: border-box;
		border-radius: 5px;
		padding: 10px;
	}

	.hr-horizontal {
		border: 1px solid #cccccc;
		margin-right: -15px;
		margin-left: -15px;
	}
		.form-check-input[type="radio"]:checked+label:after{
background-color: #f5904b;
}
.form-check-input[type="radio"]:checked+label:after{
border: 2px solid #f5904b;
}
</style>